// NewService.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./NewService.css";
import AlertModal from "./AlertModal";
import API_URL from "../config";
import api from "./Api";
export default function Blacklistclt({ k, onClose }) {
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [Reason, setReason] = useState("");
  const [idserv, setNbreserv] = useState(""); // ID réel
  const [codserv, setCodsrv] = useState(""); // ID réel
  const [modaction, setAction] = useState("1");

  const [ldate, setLdate] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [error, setError] = useState(null);
  const showModalAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };
  // Convertir k en nom client
  useEffect(() => {
    if (k) {
      const parts = k.split("@@");
      setClientName(parts[0] + "---" + parts[1]);
      setLdate(parts[4]);
      setClientCode(parts[0]);
      setNbreserv(parts[5]);
      setCodsrv(parts[6]);
    }
  }, [k]);

  useEffect(() => {
    axios
      .get(`${API_URL}/read_hist_file/`)
      .then((res) => {
        if (res.data.content) {
          setLdate(res.data.content); // initialise la date directement
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const saveService = async () => {
    if (Reason === "") {
      showModalAlert("Please fill the reason ❌");
      return;
    }

    try {
      const payload = {
        client: clientCode,
        modaction,
        Reason,
        idserv,
        codserv,
        ldate,
      };
      const response = await api.post("new_blacklist/", payload);

      setReason("");
      showModalAlert("Save succesfully ✔");

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement !");
    }
  };

  return (
    <div className="container-box">
      <div className="card9" style={{ padding: "20px" }}>
        <h3>INSERT A CLIENT INTO THE BLACKLIST</h3>

        <div className="row3">
          <div className="col-lg-3 col-md-6">
            <label className="field-label">Nom du client</label>
            <input value={clientName} disabled className="input" />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="field-label">Action</label>
            <select
              value={modaction}
              onChange={(e) => setAction(Number(e.target.value))}
              className="input"
            >
              <option value={1}>1 --- Retain in the list</option>
              <option value={2}>2 --- Remove from the list</option>
            </select>
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Today's date</label>
            <input
              type="date"
              value={ldate}
              onChange={(e) => setLdate(e.target.value)}
              className="input"
            />
          </div>
        </div>
        <div className="row3">
          <div className="col-lg-12 col-md-12">
            <label className="field-label">Reason</label>
            <input
              type="text"
              placeholder="Reason"
              value={Reason}
              onChange={(e) => setReason(e.target.value)}
              className="input"
            />
          </div>
        </div>

        <div className="row">
          <button className="btn" onClick={saveService}>
            Save
          </button>
          <button
            className="btn red"
            onClick={() => {
              if (onClose) onClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
      <AlertModal
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </div>
  );
}
